import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup, Label, Button } from 'reactstrap';
import Select from 'react-select';

const AsistenciaModal = ({
  isOpen,
  toggle,
  isEdit,
  nuevaAsistencia,
  setNuevaAsistencia,
  asistenciasOptions,
  asistenciasLoading,
  asistenciasError,
  erroresValidacion,
  onGuardar
}) => {
  // Opción seleccionada actualmente (por código)
  const selectedAsistencia = useMemo(function () {
    const list = asistenciasOptions || [];
    const code = nuevaAsistencia && nuevaAsistencia.codigo ? String(nuevaAsistencia.codigo) : '';
    for (var i = 0; i < list.length; i++) {
      var v = list[i] && list[i].value ? String(list[i].value) : '';
      if (v === code) return list[i];
    }
    return null;
  }, [asistenciasOptions, nuevaAsistencia]);

  // Cambio del select
  const handleSelect = function (opt) {
    if (!opt) {
      setNuevaAsistencia(function (prev) {
        return { ...prev, codigo: '', nombre: '' };
      });
      return;
    }
    setNuevaAsistencia(function (prev) {
      return {
        ...prev,
        codigo: opt.codigo || opt.value || '',
        nombre: opt.label || opt.nombre || ''
      };
    });
  };

  // Cambio del valor numérico
  const handleValor = function (e) {
    let val = e.target.value;
    if (val) {
      const parts = val.split('.');
      if (parts[0].length > 8) {
        parts[0] = parts[0].slice(0, 8);
        val = parts.join('.');
      }
    }
    setNuevaAsistencia(function (prev) { return { ...prev, valor: val }; });
  };

  // Asegurar que el menú de react-select se vea sobre el modal
  const selectStyles = {
    menuPortal: function (base) { return Object.assign({}, base, { zIndex: 9999 }); }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {isEdit ? 'Editar asistencia' : 'Agregar asistencia'}
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>Asistencia</Label>

          <Select
            value={selectedAsistencia}
            onChange={handleSelect}
            options={asistenciasOptions || []}
            isLoading={!!asistenciasLoading}
            isDisabled={!!asistenciasLoading || !((asistenciasOptions || []).length)}
            isClearable
            isSearchable
            placeholder={asistenciasLoading ? 'Cargando asistencias...' : 'Seleccione una asistencia de la lista'}
            noOptionsMessage={function () { return asistenciasLoading ? 'Cargando…' : 'Sin resultados'; }}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
            styles={selectStyles}
          />

          {asistenciasError && <small style={{ color: 'red' }}>{asistenciasError}</small>}
          {erroresValidacion && erroresValidacion.asistencia && <small className="d-block mt-1" style={{ color: '#dc3545', fontSize: '13px' }}>{erroresValidacion.asistencia}</small>}
          {erroresValidacion && erroresValidacion.global && <small className="d-block mt-1" style={{ color: '#dc3545', fontSize: '13px' }}>{erroresValidacion.global}</small>}
        </FormGroup>

        <FormGroup>
          <Label>Valor de la asistencia</Label>
          <Input
            type="number"
            step="0.01"
            value={nuevaAsistencia && nuevaAsistencia.valor ? nuevaAsistencia.valor : ''}
            onChange={handleValor}
            placeholder="Ej: 25.00"
            min="0"
            invalid={!!(erroresValidacion && erroresValidacion.valor)}
          />
          {erroresValidacion && erroresValidacion.valor && <small className="d-block" style={{ color: '#dc3545', fontSize: '13px' }}>{erroresValidacion.valor}</small>}
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onGuardar}>
          {isEdit ? 'Guardar cambios' : 'Agregar'}
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
      </ModalFooter>
    </Modal>
  );
};

export default AsistenciaModal;
